import React from 'react';
// Fix: Use namespace import for react-router-dom to avoid missing exported member errors
import * as ReactRouterDOM from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const { NavLink } = ReactRouterDOM as any;

// Icons
const Icon: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">{children}</svg>
);
const HomeIcon: React.FC<{className?:string}> = ({className}) => (<Icon className={className}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /></Icon>);
const DepositIcon: React.FC<{className?:string}> = ({className}) => (<Icon className={className}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" /></Icon>);
const OrderIcon: React.FC<{className?:string}> = ({className}) => (<Icon className={className}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" /></Icon>);
const UsersIcon: React.FC<{className?:string}> = ({className}) => (<Icon className={className}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M15 21v-1a6 6 0 00-1-3.749" /></Icon>);

const AdminBottomNavbar: React.FC = () => {
    const { t } = useTranslation();
    
    const navItems = [
        { name: t('admin.nav.dashboard'), path: '/admin', icon: HomeIcon },
        { name: t('admin.nav.deposits'), path: '/admin/deposits', icon: DepositIcon },
        { name: t('admin.nav.orders'), path: '/admin/orders', icon: OrderIcon },
        { name: t('admin.nav.users'), path: '/admin/users', icon: UsersIcon },
    ];

    const navLinkClasses = ({isActive}: {isActive: boolean}) => 
        `relative flex flex-col items-center justify-center text-xs gap-1 w-full h-full transition-colors ${
            isActive 
                ? 'text-primary-600 dark:text-primary-400' 
                : 'text-gray-500 dark:text-gray-400 hover:text-primary-500'
        }`;

    return (
        <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 shadow-t-lg z-40">
            <div className="flex justify-around h-16">
                {navItems.map(item => (
                    <NavLink key={item.path} to={item.path} end={item.path === '/admin'} className={navLinkClasses}>
                        <item.icon className="h-6 w-6" />
                        <span>{item.name}</span>
                    </NavLink>
                ))}
            </div>
        </div>
    );
};

export default AdminBottomNavbar;